import { Link as Link$1 } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { withUtility } from '../../foundation/utils.js';
import { alpha } from '@mui/system';

let _ = t => t,
  _t,
  _t2,
  _t3;
const Link = styled(Link$1)(_t || (_t = _`
  ${0}
  underline: always;
`), withUtility(({
  palette
}, {
  disabled
}) => {
  if (disabled) {
    return css(_t2 || (_t2 = _`
        pointer-events: none;
        cursor: default;
        text-decoration: underline;
        color: ${0};
      `), alpha(palette('onSurface'), 0.38));
  }
  return css(_t3 || (_t3 = _`
      color: ${0};
    `), palette('primary'));
}));

export { Link };
